import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["fill"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var RestartIcon = function RestartIcon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? "#111827" : _ref$fill,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24"
  }, rest), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: fill,
      d: "M5.333 5.334l1.96 1.96A6.63 6.63 0 005.333 12 6.674 6.674 0 0012 18.667a6.674 6.674 0 006.666-6.666A6.674 6.674 0 0012 5.334v1.333a5.34 5.34 0 015.333 5.334A5.34 5.34 0 0112 17.334a5.34 5.34 0 01-5.334-5.333c0-1.471.6-2.802 1.567-3.767L10 10V5.334H5.333z"
    })
  }));
};
export default RestartIcon;